import { app } from '../app.module'
app
  /**
   * @ngdoc ResetPasswordCtrl
   * @name ResetPasswordCtrl
   * @requires UserService ユーザ情報管理関連のサービス
   * @requires DialogService ダイアログ表示用のサービス
   * @description パスワードの再設定のメインコントローラー
   */
  .controller('ResetPasswordCtrl', function ($scope, $location, UserService, DialogService) {
    // router paramからユーザーを取得する
    const hash = $location.search().hash

    if (hash !== undefined && hash !== null) {
      UserService.User.checkHash(hash).then((result) => {
        if (result.error === null) {
          // パスワード入力フォームを表示
          $scope.resetStatus = 'inputPassword'
          $scope.alertMessage = '新しいパスワードを入力してください。'
          $scope.userId = result.userId
        } else if (result.error === 'hash-invalid') {
          // パスワード再設定の有効期限が切れた場合、エラーを表示
          $scope.resetStatus = 'inputPassword'
          $scope.alertMessage =
            'パスワード再設定の有効期限切れです。\n確認メールの送信後12時間以内に新しいパスワードを設定してください。'
          $scope.invalidHash = true
        } else {
          location.href = 'reset-password'
        }
      })
    } else {
      // 確認用メールアドレス入力フォームを表示
      $scope.resetStatus = 'inputMail'
      $scope.alertMessage = 'メールアドレスを入力してください。'
    }

    /**
     * changeInputValue 入力する時、スコープの値をアップデート
     * @param {string} type 対象
     * @param {string} value 入力したバリュー
     * @return {void}
     */
    $scope.changeInputValue = function (type: string, value: string) {
      if (type === 'mail') {
        $scope.email = value
      } else {
        $scope.password = value
      }
    }

    /**
     * createPassResetHash パスワード再設定のハッシュを生成
     * @return {void}
     */
    $scope.createPassResetHash = function () {
      UserService.User.createPassResetHash($scope.email).then((result) => {
        if (result !== null) {
          DialogService.showToast(
            'パスワード再設定メールを、入力したメールアドレスに送信しました。',
            'success-toast'
          )
        } else {
          // メールが存在しない場合、エラーを表示
          DialogService.showError(
            null,
            '登録されていないメールアドレスです。再度入力してください。'
          )
          $scope.isClicked = false
        }
      })
    }

    /**
     * resetPassword パスワード再設定
     * @return {void}
     */
    $scope.resetPassword = function () {
      UserService.User.resetPassword($scope.password, $scope.userId).then((result) => {
        if (result.error === null) {
          DialogService.showToast(
            'パスワードを再設定しました。新しいパスワードでログインしてください。',
            'success-toast'
          )
        } else {
          DialogService.showError(null, 'パスワード再設定が失敗しました。')
          $scope.isClicked = false
        }
      })
    }

    // ログインページにリダイレクト
    $scope.goLogin = function () {
      $location.path('start.html')
    }
  })
